<template>
  <div class="fill-height">
    <div class="fill-height">
      <div class="basketArea py-10">
        <div class="titleBasket">
          {{ $t('wallet.title') }}
        </div>
        <div class="basketContent mt-10">
          <p v-if="loading" class="text-center" role="status">{{ $t('intake.portal.loading') }}</p>
          <div v-else-if="loadError" class="text-center" role="alert">
            <p>{{ $t('intake.portal.loadError') }}</p>
            <v-btn text @click="loadCart">{{ $t('intake.bookingUi.retry') }}</v-btn>
          </div>
          <CartComponent v-else-if="!cartIsEmpty"/>
          <div class="text-center" v-else>
            <img src="../../assets/EmptyState.svg" width="250px" alt="">
            <p>
              {{ $t('emptyStateCart') }}
            </p>
            <v-btn color="blue" text :to="{name:'packages'}">
              {{ $t('packages.buy') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/*eslint-disable*/
import CartComponent from "@/components/Basket/CartComponent";
import {mapGetters} from "vuex";

export default {
  components: {CartComponent},
  computed: {
    ...mapGetters({
      cart: 'getCart',
    }),
  },
  data() {
    return {
      cartIsEmpty: true,
      loading: false,
      loadError: false,
    }
  },
  watch: {
    cart() {
      this.getStatusCart();
    }
  },
  methods: {
    loadCart() {
      if (this.loading) return Promise.resolve()
      this.loading = true
      this.loadError = false
      return this.requesting('cart', 'getCart').then((response) => {
        if (!response || String(response.type).toUpperCase() !== 'SUCCESS') throw new Error('CART_LOAD_FAILED')
        this.getStatusCart()
      }).catch(() => { this.loadError = true })
        .finally(() => { this.loading = false })
    },
    getStatusCart() {
      this.cartIsEmpty = !this.cart || !this.cart.items || Object.keys(this.cart.items).length === 0
    }
  },
  mounted() {
    this.loadCart();
  }
}
</script>

<style scoped>
.basketArea {
  min-height: 80%;
  /*max-height: auto;*/
  height: auto;
  width: 99%;
  margin: 0px auto;
  border-radius: 18px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.07);
  background-color: white;
  padding: 20px;

}

.titleBasket {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.96;
  letter-spacing: normal;
  color: rgb(0, 0, 0);
}
</style>
